<template>
  <container>
    <div class="subpage__cnt col-xl-10 offset-xl-1 text-center">

    </div>
    <div class="subpage-list uni-search-wrp">
      <div class="subpage-list-top">
        <img src="@/assets/img/building.png" alt="" class="city-dorms__icon">

        <div class="section__title-top">
          <div class="section__title">
            <span class="color-light-green">Search </span> Collections!
          </div>
          <p class="section__title-txt">You can find movies from your favorite series, you can quickly reach movies according to your series genre flavour ! </p>
        </div>
      </div>
            <div class="desktop-drop">
                <div class="section__right">
                  <div class="section__select" v-if="universityDetails"> -->
                   </div>
                </div>
              </div> 
      <Hero :filter-dorm="false"/>
      <div class="result-bracket">
        <div class="result-bracket__title">
          <span class="result-bracket__count" v-if="list">{{ total_results }}</span> <span v-if="list">Collections Found!</span>
           <span v-if="!list">Series Loading!</span> 
        </div>

<!--                     <div class="desktop-drop">
                <div class="section__right">
                  <div class="section__select" v-if="universityDetails"> -->
                    <VueSelectTempFacultyNoFilter placeholder="Select Genre" :options="genres"
                                   @onselect="selectGenre"/>
<!--                   </div>
                </div>
              </div> -->
                    <!-- <v-select :options="genres" placeholder="Select Country" @onselect="selectFaculty"/> -->
      </div>

      <div class="flex-row" v-if="movies">
        <div class="subpage-list__item"
             v-for="movie in movies"
             :key="movie.id">
          <SerieCard :city="movie" />
        </div>

  <FixedPopup :dorms="popupDorms" v-if="popupDorms && popupDorms.length > 0"/>
      </div>
      <!--<div class="featured-dorms__bottom text-center">-->
        <!--<v-link-->
          <!--to="/yurtlar"-->
          <!--class="button&#45;&#45;stroke round icon-transform"-->
          <!--title="See All"-->
          <!--icon="icon-arrow-long-right"-->
          <!--icon-position="right"-->
        <!--/>-->
      <!--</div>-->
    </div>
          <ContentLoader v-if="!list && !mobileCheck"
          :height="700">
        <rect x="20" y="0" rx="3" ry="3" width="86" height="40" />
        <rect x="110" y="0" rx="3" ry="3" width="86" height="40" />
        <rect x="202" y="0" rx="3" ry="3" width="87" height="40" />
        <rect x="293" y="0" rx="3" ry="3" width="88" height="40" />

        <rect x="20" y="45" rx="3" ry="3" width="86" height="40" />
        <rect x="110" y="45" rx="3" ry="3" width="86" height="40" />
        <rect x="202" y="45" rx="3" ry="3" width="87" height="40" />
        <rect x="293" y="45" rx="3" ry="3" width="88" height="40" />

        <rect x="20" y="90" rx="3" ry="3" width="86" height="40" />
        <rect x="110" y="90" rx="3" ry="3" width="86" height="40" />
        <rect x="202" y="90" rx="3" ry="3" width="87" height="40" />
        <rect x="293" y="90" rx="3" ry="3" width="88" height="40" />

        <rect x="20" y="135" rx="3" ry="3" width="86" height="40" />
        <rect x="110" y="135" rx="3" ry="3" width="86" height="40" />
        <rect x="202" y="135" rx="3" ry="3" width="87" height="40" />
        <rect x="293" y="135" rx="3" ry="3" width="88" height="40" />        
      </ContentLoader>1

      <ContentLoader v-if="!list && mobileCheck">
        <rect x="3" y="0" rx="3" ry="3" width="94" height="110" />      
      </ContentLoader>
  <infinite-loading @infinite="infiniteHandler" spinner="waveDots">
  <div slot="no-more"></div>
  <div slot="no-results"></div>
  </infinite-loading>
  </container>
  
</template>

<script>
import InfiniteLoading from 'vue-infinite-loading'
import FacultyCard from '@/components/UniSearchCard'
import Hero from '@/components/Home/HeroSearch.vue'
import SerieCard from '@/components/SerieCard'
import { ContentLoader } from 'vue-content-loader'
import VueSelectTempFacultyNoFilter from '@/components/VueSelectTempFacultyNoFilter'
import axios from 'axios'
export default {
  name: 'SeriesSearch',
  components: {
    FacultyCard, Hero, SerieCard, ContentLoader, VueSelectTempFacultyNoFilter, InfiniteLoading
  },
  metaInfo () {
    return {
      // if no subcomponents specify a metaInfo.title, this title will be used
      title: 'Üniversiteler',
       meta: [
         { vmid: 'description', name: 'description', content: 'You can find movies you search for, you can get news for the series you want, you can reach the movies in your favroite sires quickly!' },
         { vmid: 'keywords', name: 'keywords', content: 'hollywood movies, hollywod films, american movies, american cinema, holywoodskyline, movie search, yurt ara' }
       ],
       link: [
         { rel: 'canonical', href: window.location.origin + '/universiteler/' }
       ]      
    }
  },  
  data () {
    return {
      // list: null,
      page: 2,
      total_results: null,
genres: [
{name: 'All Genres', code: 'DE'},
{name: 'Adventure', code: 'DE'},
{name: 'Superhero', code: 'SE'},
{name: 'Animation', code: 'FR'},
{name: 'Horror', code: 'IT'},
{name: 'Science Fiction', code: 'DK'},
{name: 'Action', code: 'GB'},
{name: 'Drama', code: 'US'},
{name: 'Canada', code: 'CA'},
{name: 'Family', code: 'NZ'},
{name: 'Fantasy', code: 'MX'},
{name: 'Japan', code: 'JP'},
{name: 'Russia', code: 'RU'},
{name: 'Brasil', code: 'BR'},
{name: 'Belgium', code: 'BE'},
{name: 'Crotia', code: 'HR'},
{name: 'Australia', code: 'AU'},
{name: 'Finland', code: 'FI'},
{name: 'Switzerland', code: 'CH'},
{name: 'Chez Republic', code: 'CZ'},
{name: 'Austria', code: 'AT'},
{name: 'Luxemburg', code: 'LU'},
{name: 'South Korea', code: 'KR'},
{name: 'Spain', code: 'ES'},
{name: 'Norwey', code: 'NO'},
{name: 'Israel', code: 'IS,'}
      ],
      movies: null,      
      list: [
{
  genre: "Action",
  id: 10,
  name: "Star Wars Collection",
  overview: "An epic space-opera theatrical film series, which depicts the adventures of various characters \"a long time ago in a galaxy far, far away….\"",
  poster_path: "/r8Ph5MYXL04Qzu4QBbq2KjqwtkQ.jpg",
  backdrop_path: "/d8duYyyC9J5T825Hg7grmaabfxQ.jpg"
},
    {
      genre: "Animation",
      backdrop_path: "/2fNfuntrA7I4SGNTaGF0deLMiwW.jpg",
      id: 302331,
      name: "Lego Star Wars Collection",
      original_language: "en",
      original_name: "Lego Star Wars Collection",
      overview: "A set of animated Lego movies based in the Star Wars universe, but with a jest overarching one.",
      poster_path: "/xRzsoQmCP0rUy4R8cF5QSgy4VDR.jpg"
    },
{
  genre: "Horror",
  id: 656,
  name: "Saw Collection",
  overview: "The extremely successful horror film series about a mysterious murderer who gives his victims macabre riddles they must solve to earn their freedom. After a surprise debut film success Saw would be made into a multimedia franchise, spawning 7 installments.",
  poster_path: "/xmC2A7qPEfiOkQC58fZh8srWQ5v.jpg",
  backdrop_path: "/oLfS1lOmN2KIU2IQ200SDEPVEZe.jpg"
 },
{
  genre: "Animation",
  id: 386410,
  name: "Dragon Ball Collection",
  overview: "A Collection Of Dragon Ball Movies.",
  poster_path: "/7gksLHQSrsyuQQKh9EHPUYfINtR.jpg",
  backdrop_path: "/i5ECrR2zT7GQl0J8WdyGTm9D6d6.jpg"
},
{
  genre: "Animation",
  id: 34055,
  name: "Pokémon Collection",
  overview: "",
  poster_path: "/oUdOt0VbJQnkLwOiQLPJLxH8oCA.jpg",
  backdrop_path: "/xQM02GXLgC0HxMHOCUIxTsjzi1O.jpg"
},
{
  genre: "Fantasy",
  id: 1241,
  name: "Harry Potter Collection",
  overview: "The Harry Potter films are a fantasy series based on the series of seven Harry Potter novels by British writer J. K. Rowling.",
  poster_path: "/eVPs2Y0LyvTLZn6AP5Z6O2rtiGB.jpg",
  backdrop_path: "/wfnMt6LGqYHcNyOfsuusw5lX3bL.jpg"
},
{
  genre: "Fantasy",
  id: 435259,
  name: "Fantastic Beasts Collection",
  overview: "The Fantastic Beasts films are a fantasy series based on and inspired by the textbook mentioned in the Harry Potter novels by British writer J. K. Rowling. Set in the same Wizarding World franchise, they follow the adventures of Newt Scamander a self-proclaimed magizoologist along with Porpentina \"Tina\" Goldstein a MACUSA auror.",
  poster_path: "/wsVseA7i3FqX24m26Z2gD3EtH4l.jpg",
  backdrop_path: "/3ybt95EcivmtIynUq6kisWsGnEo.jpg"
},
{
  genre: "Fantasy",
  id: 119,
  name: "The Lord of the Rings Collection",
  overview: "The Lord of the Rings trilogy consists of three epic fantasy films, based on the influential novels written by J. R. R. Tolkien, directed by Peter Jackson.",
  poster_path: "/p4UokEk2XnjjRTdXGe6DLYXlbI1.jpg",
  backdrop_path: "/bccR2CGTWVVSZAG0yqmy3DIvhTX.jpg"
 },
{
  genre: "Fantasy",
  id: 121938,
  name: "The Hobbit Collection",
  overview: "The Hobbit collection is a three-part epic fantasy-adventure film directed and produced by Peter Jackson and based on J. R. R. Tolkien's fantasy novel of the same name. The trilogy of films are set in Middle-earth 60 years before \"The Lord of the Rings\", and will act as a prequel to Jackson's The Lord of the Rings trilogy.",
  poster_path: "/j4e06Vg7Rb3Z4rN17kOtDS5Q8pD.jpg",
  backdrop_path: "/7wO7MSnP5UcwR2cTHdJFF1vP4Ie.jpg"
},
{
  genre: "Action",
  id: 131635,
  name: "The Hunger Games Collection",
  overview: "A science fiction film series based on the novel of the same name by Suzanne Collins. The film series takes place in a dystopian post-apocalyptic future in the nation of Panem, featuring the protagonist, Katniss Everdeen.",
  poster_path: "/wrWNUgkBqWyR619tNhg1upWhkHw.jpg",
  backdrop_path: "/zWiiLNg8yXv0he3tCH6XignPaYV.jpg"
},
    {
      genre: "Superhero",
      backdrop_path: "/3JFe9AWoKuQWox7HO8HKgYRMOF7.jpg",
      id: 9744,
      name: "Fantastic Four Collection",
      original_language: "en",
      original_name: "Fantastic Four Collection",
      overview: "Superhero films based on the Marvel Comics team of the same name. Four individuals gained superpowers after exposure to cosmic rays during a scientific mission to outer space: Mister Fantastic (Reed Richards), the Invisible Woman (Susan \"Sue\" Storm), the Human Torch (Johnny Storm), and the monstrous Thing (Ben Grimm).",
      poster_path: "/prObnUSCHIBC8ZjkGo2KHgjkWOo.jpg"
    },
{
  genre: "Superhero",
  id: 131296,
  name: "Thor Collection",
  overview: "A superhero film series based on the comic book character of the same name published by Marvel Comics, and part of the Marvel Cinematic Universe (MCU) film series. The series centers on Thor, the crown prince of Asgard.",
  poster_path: "/yw7gr7DhHHVTLlO8Se8uH17TDMA.jpg",
  backdrop_path: "/3KL8UNKFWgIKXzLHjwY0uwgjzYl.jpg"
},
    {
      genre: false,
      backdrop_path: "/JhGydj4q5y8MoWZFyj15yKNrzC.jpg",
      id: 1575,
      name: "Rocky Collection",
      original_language: "en",
      original_name: "Rocky Collection",
      overview: "These sport drama films begin by telling the rags to riches American Dream story of Rocky Balboa, an uneducated but kind-hearted working class Italian-American boxer working as a debt collector for a loan shark in the slums of Philadelphia.",
      poster_path: "/O66XFv0mU6JKfmrgkoTQLwbFDG.jpg"
    }
,    {
      genre: false,
      backdrop_path: "/pvyoF4jsboXhmU3VLpHL1SyVaNI.jpg",
      id: 553717,
      name: "Creed Collection",
      original_language: "en",
      original_name: "Creed Collection",
      overview: "Former World Heavyweight Champion Rocky Balboa serves as a trainer and mentor to Apollo Creed's son, Adonis. These films are both spin-offs and sequels to the Rocky film series.",
      poster_path: "/c5iwhO9Oqx5zusx0VeaoyxP50Wr.jpg"
    },
    {
      genre: "Action",
      backdrop_path: "/9vlISRco1XbV7xa038IpLcDtBSV.jpg",
      id: 5039,
      name: "Rambo Collection",
      original_language: "en",
      original_name: "Rambo Collection",
      overview: "A series of action films that follows John Rambo, a US Army veteran, who is traumatized by his experience in the Vietnam War, and uses the skills he gained there to fight corrupt police officers, enemy troops and drug cartels.",
      poster_path: "/feGOEOVrOLyjtEnVa88rQLgD3XY.jpg"
    },
    {
      genre: "Action",
      backdrop_path: "/z5A5W3WYJc3UVEWljSGwdjDgQ0j.jpg",
      id: 9485,
      name: "The Fast and the Furious Collection",
      original_language: "en",
      original_name: "The Fast and the Furious Collection",
      overview: "An action film series centered on illegal street racing and heists.",
      poster_path: "/uv63yAGg1zETAs1XQsOQpava87l.jpg"
    },
    {
      genre: "Action",
      backdrop_path: "/zWiiLNg8yXv0he3tCH6XignPaYV.jpg",
      id: 131635,
      name: "The Hunger Games Collection",
      original_language: "en",
      original_name: "The Hunger Games Collection",
      overview: "A science fiction film series based on the novel of the same name by Suzanne Collins. The film series takes place in a dystopian post-apocalyptic future in the nation of Panem, featuring the protagonist, Katniss Everdeen.",
      poster_path: "/wrWNUgkBqWyR619tNhg1upWhkHw.jpg"
    },
    {
      genre: "Superhero",
      backdrop_path: "/rI8zOWkRQJdlAyQ6WJOSlYK6JxZ.jpg",
      id: 131292,
      name: "Iron Man Collection",
      original_language: "en",
      original_name: "Iron Man Collection",
      overview: "A superhero film series based on the Marvel Comics character of the same name and part of the Marvel Cinematic Universe (MCU) series. Tony Stark AKA Iron Man, an industrialist and master engineer uses a powered exoskeleton to fight foes, with the aid of his personal assistant and love interest Pepper Potts.",
      poster_path: "/fbeJ7f0aD4A112Bc1tnpzyn82xO.jpg"
    },
    {
      genre: "Superhero",
      backdrop_path: "/waZqriYTuBE3WqXI3SDGi3kfDQE.jpg",
      id: 556,
      name: "Spider-Man Collection",
      original_language: "en",
      original_name: "Spider-Man Collection",
      overview: "A superhero film series based on the Marvel Comics character Spider-Man. The series is centered on Peter Parker, an academically gifted but socially inept freelance photographer who gets bitten by a genetically modified spider and gains spider-like abilities, all of which he uses to fight crime as a spider-masked vigilante learning for himself that great power comes with great responsibility.",
      poster_path: "/bp5PqLa06QA1LsELA1SsKZ008H7.jpg"
    },
    {
      genre: "Superhero",
      backdrop_path: "/zh72eVJTD5EssStCsNHqELuh6uD.jpg",
      id: 531241,
      name: "Spider-Man (Avengers) Collection",
      original_language: "en",
      original_name: "Spider-Man (Avengers) Collection",
      overview: "A superhero film series based on the Marvel character Spider-Man, portrayed by Tom Holland. The series is centered on Peter Parker, an academically gifted but socially inept high school student who fights crime as Spider-Man, a member of The Avengers.",
      poster_path: "/nogV4th2P5QWYvQIMiWHj4CFLU9.jpg"
    },
    {
      genre: "Superhero",
      backdrop_path: "/14F6gMaRjzgsN6EEpiwH87R1I00.jpg",
      id: 573436,
      name: "Spider-Man: Spider-Verse Collection",
      original_language: "en",
      original_name: "Spider-Man: Spider-Verse Collection",
      overview: "Spider-Man animated film series focusing on Miles Morales.",
      poster_path: "/eD4bGQNfmqExIAzKdvX5gDHhI2.jpg"
    },
    {
      genre: "Superhero",
      backdrop_path: "/aLrNTcLN2kDu9jAJ4tS5haiWGc6.jpg",
      id: 125574,
      name: "The Amazing Spider-Man Collection",
      original_language: "en",
      original_name: "The Amazing Spider-Man Collection",
      overview: "A superhero film series based on the Marvel Comics character Spider-Man. The series is centered on Peter Parker, a teenager struggling to find his place in life ever since his parents disappeared when he was a child. A spider bites him on the back of his neck, giving him spider-powers. It is a reboot of Sony's Spider-Man film franchise.",
      poster_path: "/68CqVxCH14br7EHFu67peDDjZX9.jpg"
    },
    {
      genre: "Superhero",
      backdrop_path: "/rkVIb2JS3C2DBtjX8szbg37Qwff.jpg",
      id: 225941,
      name: "The Amazing Spider-Man TV Collection",
      original_language: "it",
      original_name: "The Amazing Spider-Man TV Collection",
      overview: "Made for TV pilot and two 2 part episodes loosely referred to as sequels (The Deadly Dust and The Chinese Web).",
      poster_path: "/w36EVLGahaKWivtGeXnLsEXhOCO.jpg"
    },
    {
      genre: "Superhero",
      backdrop_path: "/csERw2A3XIsGegkzil6UGpyhqfw.jpg",
      id: 209131,
      name: "Man of Steel Collection",
      original_language: "de",
      original_name: "Man of Steel Collection",
      overview: "Man of Steel is a 2013 British-American superhero film featuring the DC Comics character Superman. It was co-produced by Legendary Pictures and Syncopy Films, and distributed by Warner Bros. Pictures. It is the first installment in the DC Extended Universe. Directed by Zack Snyder and written by David S. Goyer, the film stars Henry Cavill as the title character. It is a reboot of the Superman film series. A 2016 sequel, Batman v Superman: Dawn of Justice is the first live-action film to feature Batman and Superman together.",
      poster_path: "/rNnIW6xSPeTiIUtsfEhFeIRiJVv.jpg"
    },
    {
      genre: "Superhero",
      backdrop_path: "/9DA9dxRE0fRlpl4amBmLCjQdZay.jpg",
      id: 286904,
      name: "Ultimate Avengers Collection",
      original_language: "en",
      original_name: "Ultimate Avengers Collection",
      overview: "When a nuclear missile was fired at Washington in 1945, Captain America managed to detonate it in the upper atmosphere. But then he fell miles into the icy depths of the North Atlantic, where he remained lost for over sixty years. But now, with the world facing the very same evil, Captain America must rise again as our last hope for survival.",
      poster_path: "/bOXJmKCHKtqJILiJ5womPDigEoc.jpg"
    },
    {
      genre: "Superhero",
      backdrop_path: null,
      id: 482721,
      name: "Alien Avengers Collection",
      original_language: "en",
      original_name: "Alien Avengers Collection",
      overview: "Alien Avengers (Welcome to Planet Earth) and Alien Avengers II (Aliens Among Us)",
      poster_path: null
    },
    {
      genre: "Superhero",
      backdrop_path: "/zuW6fOiusv4X9nnW3paHGfXcSll.jpg",
      id: 86311,
      name: "The Avengers Collection",
      original_language: "en",
      original_name: "The Avengers Collection",
      overview: "A superhero film series produced by Marvel Studios based on the Marvel Comics superhero team of the same name, and part of the Marvel Cinematic Universe (MCU).  The series features an ensemble cast from the Marvel Cinematic Universe series films, as they join forces for the peacekeeping organization S.H.I.E.L.D. led by Nick Fury.",
      poster_path: "/bvjltR2nDuhf1NlnwCrgNwvHuIh.jpg"
    },
    {
      genre: "Superhero",
      backdrop_path: "/tp0buiNBb6iFjlr34lCB9ardTEA.jpg",
      id: 522577,
      name: "Avengers Grimm Collection",
      original_language: "en",
      original_name: "Avengers Grimm Collection",
      overview: "Avengers Grimm is a 2015 American fantasy action adventure film written, co-edited, and directed by Jeremy M. Inman. The film, produced by B-movie film company The Asylum, stars Casper Van Dien, Lou Ferrigno, Kimo Leopoldo, Lauren Parkinson, Milynn Sarley, Marah Fairclough, Rileah Vanderbilt, and Elizabeth Peterson. Avengers Grimm received a direct sequel in 2018 through Avengers Grimm: Time Wars while also having gotten a loose spin-off through Sinister Squad in 2016.",
      poster_path: "/oqEp8zCTK7mTKeeEHCTCkT3pMLx.jpg"
    },
    {
      genre: "Superhero",
      backdrop_path: "/zh72eVJTD5EssStCsNHqELuh6uD.jpg",
      id: 531241,
      name: "Spider-Man (Avengers) Collection",
      original_language: "en",
      original_name: "Spider-Man (Avengers) Collection",
      overview: "A superhero film series based on the Marvel character Spider-Man, portrayed by Tom Holland. The series is centered on Peter Parker, an academically gifted but socially inept high school student who fights crime as Spider-Man, a member of The Avengers.",
      poster_path: "/nogV4th2P5QWYvQIMiWHj4CFLU9.jpg"
    },
    {
      genre: "Superhero",
      backdrop_path: "/c5ccDw4lcTUnYGdCxc2yEl8PjTk.jpg",
      id: 115762,
      name: "AVP Collection",
      original_language: "en",
      original_name: "AVP Collection",
      overview: "The Alien vs. Predator (also known as AVP) collection is a science fiction film series bringing together the eponymous creatures of the Alien and Predator series.",
      poster_path: "/zrApSsUX9i0qVntcCD0Pp55TdCy.jpg"
    },
    {
      genre: "Drama",
      backdrop_path: "/vhgPpFwb7Px6xAlIX09S1IhGXHl.jpg",
      id: 441439,
      name: "Alienation Trilogy",
      original_language: "en",
      original_name: "Alienation Trilogy",
      overview: "Michelangelo Antonioni's \"trilogy on modernity and its discontents\" — L'Avventura (1960), La Notte (1961), and L'Eclisse (1962).",
      poster_path: "/dsqk2vt1t16EKxoVk31NSZcPmR2.jpg"
    },
    {
      genre: "Science Fiction",
      backdrop_path: "/kB0Y3uGe9ohJa59Lk8UO9cUOxGM.jpg",
      id: 8091,
      name: "Alien Collection",
      original_language: "en",
      original_name: "Alien Collection",
      overview: "A science fiction horror film franchise, focusing on Lieutenant Ellen Ripley (Sigourney Weaver) and her battle with an extraterrestrial life-form, commonly referred to as \"the Alien\". Produced by 20th Century Fox, the series started with the 1979 film Alien, then Aliens in 1986, Alien³ in 1992, and Alien: Resurrection in 1997.",
      poster_path: "/iVzIeC3PbG9BtDAudpwSNdKAgh6.jpg"
    },
    {
      genre: "Science Fiction",
      backdrop_path: "/gWl5pN2FplE709aVtA4lakwsE6t.jpg",
      id: 115575,
      name: "Star Trek: Alternate Reality Collection",
      original_language: "en",
      original_name: "Star Trek: Alternate Reality Collection",
      overview: "J.J. Abrams' cinematic re-envisioning of the Star Trek universe portrayed by a new cast, and set in an alternate reality from earlier films and series (referred to as the \"Kelvin\" timeline).",
      poster_path: "/w2IVqa43Ge49mrY3qSaJWpyDtz6.jpg"
    },
    {
      genre: "Science Fiction",
      backdrop_path: "/9BQj9hq0aK6yM9Tm2NJ28jg572y.jpg",
      id: 151,
      name: "Star Trek: The Original Series Collection",
      original_language: "en",
      original_name: "Star Trek: The Original Series Collection",
      overview: "Star Trek: Original Motion Picture Collection contains the first six Original Series films starring the U.S.S. Enterprise's cast and crew from the 1960s TV series of the same name.",
      poster_path: "/zcB8KxHA4EapOoZZPAvwgmE1iGK.jpg"
    },
    {
      genre: "Science Fiction",
      backdrop_path: "/r7MMQenUURHhAVHFymtOb8AX4Bm.jpg",
      id: 115570,
      name: "Star Trek: The Next Generation Collection",
      original_language: "en",
      original_name: "Star Trek: The Next Generation Collection",
      overview: "Star Trek: The Next Generation Motion Picture Collection contains the four Next Generation films.",
      poster_path: "/sddV6vaUC6x37icJS3opIXTXB07.jpg"
    },
    {
      genre: "Action",
      backdrop_path: "/jYl0UuJFcmhymv9ZNO14lPLDY1Z.jpg",
      id: 87359,
      name: "Mission: Impossible Collection",
      original_language: "en",
      original_name: "Mission: Impossible Collection",
      overview: "Mission: Impossible is a series of a secret agent thriller films based on the popular television series. They chronicle the missions of a team of secret government agents known as the Impossible Missions Force (IMF) under the leadership of Hunt.",
      poster_path: "/geEjCGfdmRAA1skBPwojcdvnZ8A.jpg"
    },
    {
      genre: "Action",
      backdrop_path: "/dOSECZImeyZldoq0ObieBE0lwie.jpg",
      id: 645,
      name: "James Bond Collection",
      original_language: "en",
      original_name: "James Bond Collection",
      overview: "The James Bond film series is a British series of spy films based on the fictional character of MI6 agent James Bond, codename \"007\". With all of the action, adventure, gadgetry & film scores that Bond is famous for.  (We do not consider the 1954 release of Casino Royale for this series because it was actually a television episode and not a theatrical film.)",
      poster_path: "/HORpg5CSkmeQlAolx3bKMrKgfi.jpg"
    },
    {
      genre: "Horror",
      backdrop_path: "/y3aWOInifbGKXM34KjtcMITrZRZ.jpg",
      id: 8864,
      name: "Final Destination Collection",
      original_language: "en",
      original_name: "Final Destination Collection",
      overview: "Final Destination is a series of horror films centered on the themes of fatalism, predestination, and precognition, in relation to death.",
      poster_path: "/nr4MXTXK2in9gxYhFMQGni66KRJ.jpg"
    },
    {
      genre: "Superhero",
      backdrop_path: "/4UHZWw5lV3ZoadTjXuVOakdH32L.jpg",
      id: 120794,
      name: "Batman Collection",
      original_language: "en",
      original_name: "Batman Collection",
      overview: "The Tim Burton and Joel Schumacher tetralogy film series of the DC Comics character Batman.",
      poster_path: "/adQxUvQW8HXNsvMG5aj71pHh9T.jpg"
    },
    {
      genre: "Superhero",
      backdrop_path: "/xfKot7lqaiW4XpL5TtDlVBA9ei9.jpg",
      id: 263,
      name: "The Dark Knight Collection",
      original_language: "en",
      original_name: "The Dark Knight Collection",
      overview: "Christopher Nolan's series reboot of the Batman franchise.",
      poster_path: "/bqS2lMgGkuodIXtDILFWTSWDDpa.jpg"
    },
    {
      genre: "Superhero",
      backdrop_path: "/yCXuvuBUL2tFHXiSQkVSDWp1WIz.jpg",
      id: 248534,
      name: "Batman: The Dark Knight Returns Collection",
      original_language: "en",
      original_name: "Batman: The Dark Knight Returns Collection",
      overview: "Batman: The Dark Knight Returns is a two-part animated superhero film, an adaptation of the 1986 comic book \"The Dark Knight Returns\" by Frank Miller.",
      poster_path: "/lvjiiFOKska8o4qGbOpdvYBsJQ0.jpg"
    },	
    {
      genre: "Superhero",
      backdrop_path: null,
      id: 696630,
      name: "The Lego Batman Collection",
      original_language: "en",
      original_name: "The Lego Batman Collection",
      overview: "A series of batman films based on the toys of the same name.",
      poster_path: null
    },
    {
      genre: "Superhero",
      backdrop_path: "/cp26uC7hCTXto8bAYYuKICQNBMl.jpg",
      id: 356688,
      name: "Batman Unlimited Collection",
      original_language: "en",
      original_name: "Batman Unlimited Collection",
      overview: "The animated adventures of Batman Unlimited.",
      poster_path: "/kbRFPlkkZn0IqMXNDR4WSf5gato.jpg"
    },
    {
      genre: "Superhero",
      backdrop_path: "/36nlV0NWa4NUtLx89PzqtC9K9aG.jpg",
      id: 379475,
      name: "Batman Beyond Collection",
      original_language: "en",
      original_name: "Batman Beyond Collection",
      overview: "",
      poster_path: "/xG8Yp931L9J9akALwOK4jAAjlfY.jpg"
    },
    {
      genre: "Superhero",
      backdrop_path: "/sVvEkTNx6SjwOb80iyURe5KHtcD.jpg",
      id: 334996,
      name: "Son of Batman Collection",
      original_language: "en",
      original_name: "Son of Batman Collection",
      overview: "This collection expands the story line of Batman within the DC Animated Movie Universe.  Batman learns that he has a violent, unruly pre-teen son with Talia al Ghul named Damian Wayne who is secretly being raised by Ra's al Ghul and the League of Assassins. When Ra's al Ghul apparently dies after a battle with Deathstroke, Batman must work to stop his long-lost son from taking revenge and guiding him to a righteous path, in addition to the chance for the pair to truly acknowledging each other as family.",
      poster_path: "/n3vUlxsFSSDdcmbk8sPpN744vPs.jpg"
    },
    {
      genre: "Superhero",
      backdrop_path: "/la0EhOrgVAiY8sf3ILz3wgoaNXH.jpg",
      id: 8537,
      name: "Superman Collection",
      original_language: "en",
      original_name: "Superman Collection",
      overview: "This collection includes the original superhero film series of the DC Comics character Superman starring Christopher Reeve and the fifth and final instalment, Superman Returns, from 2006. The series is centred on Clark Kent, a Kryptonian from the planet Krypton whose birth name is Kal-El. Superman resides in the city of Metropolis, where he works as a journalist for the Daily Planet, a newspaper.",
      poster_path: "/AaSF0IxlWb959ZHFN20oDpZ9GJr.jpg"
    },
    {
      genre: "Superhero",
      backdrop_path: "/ufosHrm2Qh4AUpQPxIjxqBwY5pP.jpg",
      id: 290933,
      name: "Superman / Batman (Animated) Collection",
      original_language: "en",
      original_name: "Superman / Batman (Animated) Collection",
      overview: "Superman / Batman",
      poster_path: "/hj0AOSamY8YMK9fs5by9oX7MiOO.jpg"
    },
    {
      genre: "Superhero",
      backdrop_path: null,
      id: 404770,
      name: "Superman (DC Universe Animated) Collection",
      original_language: "en",
      original_name: "Superman (DC Universe Animated) Collection",
      overview: "The Adventures of Superman within the DCAU",
      poster_path: "/ivPaMXENunntvDUTqmlpT6VsSkt.jpg"
    },
    {
      genre: "Superhero",
      backdrop_path: "/xKL7q00o6kIME7h8XY9gu3CcaDt.jpg",
      id: 593251,
      name: "Superman (DC Animated Movie Universe) Collection",
      original_language: "en",
      original_name: "Superman (DC Animated Movie Universe) Collection",
      overview: "This collection expands the story line of Superman within the DC Animated Movie Universe.  When a hulking monster arrives on Earth and begins a mindless rampage, the Justice League is quickly called in to stop it. But it soon becomes apparent that only Superman can stand against the monstrosity.  In the wake of The Death of Superman, the world is still mourning the loss of the Man of Steel following his fatal battle with the monster Doomsday. However, no sooner as his body been laid to rest than do four new bearers of the Superman shield come forward to take on the mantle. The Last Son of Krypton, Superboy, Steel, and the Cyborg Superman all attempt to fill the vacuum left by the world's greatest champion. Meanwhile, Superman's death has also signaled to the universe that Earth is vulnerable. Can these new Supermen and the rest of the heroes prove them wrong?",
      poster_path: "/1q0xylleTn1CyFWShX3uv97aJbC.jpg"
    },
    {
      genre: "Superhero",
      backdrop_path: "/csERw2A3XIsGegkzil6UGpyhqfw.jpg",
      id: 209131,
      name: "Man of Steel Collection",
      original_language: "de",
      original_name: "Man of Steel Collection",
      overview: "Man of Steel is a 2013 British-American superhero film featuring the DC Comics character Superman. It was co-produced by Legendary Pictures and Syncopy Films, and distributed by Warner Bros. Pictures. It is the first installment in the DC Extended Universe. Directed by Zack Snyder and written by David S. Goyer, the film stars Henry Cavill as the title character. It is a reboot of the Superman film series. A 2016 sequel, Batman v Superman: Dawn of Justice is the first live-action film to feature Batman and Superman together.",
      poster_path: "/rNnIW6xSPeTiIUtsfEhFeIRiJVv.jpg"
    },
    {
      genre: "Animation",
      backdrop_path: "/zvZBNNDWd5LcsIBpDhJyCB2MDT7.jpg",
      id: 8650,
      name: "Transformers Collection",
      original_language: "en",
      original_name: "Transformers Collection",
      overview: "The Transformers series follows the continuing battle between the Autobots and the Decepticons and ultimately, the triumph of good over evil. This collection includes the Theatrically Released Films of the transformers saga only.",
      poster_path: "/giURBCO3r4LVbhywEjIuYz92fEv.jpg"
    },
    {
      genre: "Animation",
      backdrop_path: "/AqPzj9uvp1aZt5zm0wAyJCFcGA9.jpg",
      id: 693368,
      name: "Scooby Doo Animated Collection",
      original_language: "es",
      original_name: "Scooby Doo Animated Collection",
      overview: "Scooby-Doo collection of cartoon movies.",
      poster_path: "/frEVR932OGVF1zCWWewlh9KKrZy.jpg"
    },
    {
      genre: "animation",
      backdrop_path: "/j2Ojh23iL4T5uNbEFwCikjXQXjF.jpg",
      id: 141290,
      name: "The Lord of the Rings Animated Collection",
      original_language: "en",
      original_name: "The Lord of the Rings (Animated) Collection",
      overview: "A collection of the animated The Lord of the Rings movies.",
      poster_path: "/pQuazFOlGRdn2Lb3oWFJYPeASOc.jpg"
    },    
    {
      genre: "Science Fiction",
      backdrop_path: "/fXVzk9OxQwROCuiWvd0Cv76qmZi.jpg",
      id: 399,
      name: "Predator Collection",
      original_language: "en",
      original_name: "Predator Collection",
      overview: "A science fiction action film series centered on a warrior class extraterrestrial species with technologically advanced weaponry that travel to Earth to trophy hunt human beings.",
      poster_path: "/6Z7lASptoiRVxiCFvZaFgH9qp7u.jpg"
    },
    {
      genre: "Science Fiction",
      backdrop_path: "/c5ccDw4lcTUnYGdCxc2yEl8PjTk.jpg",
      id: 115762,
      name: "AVP Collection",
      original_language: "en",
      original_name: "AVP Collection",
      overview: "The Alien vs. Predator (also known as AVP) collection is a science fiction film series bringing together the eponymous creatures of the Alien and Predator series.",
      poster_path: "/zrApSsUX9i0qVntcCD0Pp55TdCy.jpg"
    },
    {
      genre: "Science Fiction",
      backdrop_path: "/azQScQWHpz5puIV4YeCcqgiT9Tn.jpg",
      id: 5547,
      name: "RoboCop Collection",
      original_language: "en",
      original_name: "RoboCop Collection",
      overview: "RoboCop is a 1987 American cyberpunk action film directed by Paul Verhoeven and written by Edward Neumeier and Michael Miner. The film stars Peter Weller, Nancy Allen, Dan O'Herlihy, Kurtwood Smith, Miguel Ferrer, and Ronny Cox. Set in a crime-ridden Detroit, Michigan, in the near future, RoboCop centers on police officer Alex Murphy who is brutally shot to death by a gang of criminals and subsequently revived by the megacorporation Omni Consumer Products (OCP) as a superhuman cyborg law enforcer known as \"RoboCop\". Collection includes 2 sequels.",
      poster_path: "/foJBQb9oEOH0mGh77tXyoxXCfzU.jpg"
    },
    {
      genre: "Science Fiction",
      backdrop_path: "/1ynqKxPc4sgDdweAItGt4QLDWkS.jpg",
      id: 91697,
      name: "Battlestar Galactica (Reboot) Collection",
      original_language: "en",
      original_name: "Battlestar Galactica (Reboot) Collection",
      overview: "Follows the trials of the Colonial Fleet vessel Battlestar Galactica as it leads the last remaining humans on a search for Earth.  It's been 40 years since the 12 colonies of mankind have heard from their progeny, the Cylons -- robotic creatures who rose up and declared war on their masters, then disappeared. In a sudden, devastating strike, the Cylons return and lay waste to the colonies, aided by human-looking Cylon variants and an unwitting fifth columnist. The attack forces Commander William Adama to call into action his museum-piece warship, the Battlestar Galactica, and soon its company of hotshot fighter pilots is blasting away at the invaders. But their best efforts can't prevent the colonies' obliteration. Fleeing the Cylon genocide, the Galactica leads a rag-tag fleet of survivors on a lonely quest to find humanity's fabled 13th colony -- a planet known as Earth",
      poster_path: "/yB7QLUglaZSCFtC30emJEqfGuWi.jpg"
    },
    {
      genre: false,
      backdrop_path: "/vI7quFooOFY81OjV5JrR8m7DvNU.jpg",
      id: 284151,
      name: "Battlestar Galactica (Original) Collection",
      original_language: "de",
      original_name: "Battlestar Galactica (Original) Collection",
      overview: "Battlestar Galactica is an American science fiction franchise created by Glen A. Larson. The franchise began with the original television series in 1978 and was later followed by a short-run sequel series (Galactica 1980) and three movies.",
      poster_path: "/8G87CF4jNqhmUNkTyInEo8K6pxb.jpg"
    },
    {
      genre: "Science Fiction",
      backdrop_path: "/bSHZIvLoPBWyGLeiAudN1mXdvQX.jpg",
      id: 422837,
      name: "Blade Runner Collection",
      original_language: "en",
      original_name: "Blade Runner Collection",
      overview: "An American neo-noir science-fiction film series set in a dystopian Los Angeles, depicting a future in which synthetic humans known as \"replicants\" are bio-engineered by the powerful Tyrell Corporation, to work on off-world colonies. Based on the novel Do Androids Dream of Electric Sheep?",
      poster_path: "/cWESb1o9lW2i2Z3Xllv9u40aNIk.jpg"
    },
    {
      genre: "Fantasy",
      backdrop_path: "/ev9QybDDzVSahJQdOb71ZuqNVAo.jpg",
      id: 735,
      name: "Blade Collection",
      original_language: "en",
      original_name: "Blade Collection",
      overview: "The successful blockbuster vampire series with Wesley Snipes in the lead role.",
      poster_path: "/ltjxGZP6aJrwjl7oOZiiZhFgkF1.jpg"
    },
    {
      genre: "Action",
      backdrop_path: "/x4lV85mb7eDuibGS5Y5Hu1xqbdH.jpg",
      id: 102940,
      name: "Broken Blade Collection",
      original_language: "en",
      original_name: "Break Blade Collection",
      overview: "Rygart Arrow is the only one in his world who lacks the inherent ability to power up quartz, the energy source that makes all of the machines run. Nevertheless, he's pretty well connected. The King and Queen of his country of Krisna happen to be old college friends. But so is Zess, the guy who is leading the army of a neighboring kingdom in an attack on Krisna.  How did it comes to this? There's little time to ponder the implications as an army in giant, mechanized battle suits attacks. Arrow just feels like he's in the way - until he comes across a powerful, ancient mech that no one has yet to be able to figure out how to run. But his natural affinity for the suit's operating mechanism may just turn Arrow into the most important player of all.",
      poster_path: "/jQxHmUjcESqSA311APo9UYAROF6.jpg"
    },
	    {
      genre: "Adventure",
      backdrop_path: "/msP6KquobzwU0osaX22oWXEykR3.jpg",
      id: 201061,
      name: "War of the Worlds Collection",
      original_language: "cs",
      original_name: "War of the Worlds Collection",
      overview: "Films by The Asylum based on H.G. Wells' War of the Worlds.",
      poster_path: "/f8fd5ofLquT4U8XFtx7G5AHqVTY.jpg"
    },
    {
      genre: "Fantasy",
      backdrop_path: "/jz7bMV4D6a0x81bfEZEVMXTqric.jpg",
      id: 565841,
      name: "The Immortal Wars Collection",
      original_language: "en",
      original_name: "The Immortal Wars Collection",
      overview: "The Immortal War is an American sci-fi movie based on the comic book \"The Vanquishers\". Second movie called The Immortal War: Resurgence is due out in 2019. A third movie is due in 2020 currently called The Immortal War 3.",
      poster_path: "/q6H8cPn4D2DELNrJbDrTJSkLH4d.jpg"
    },	
    {
      genre: "Horror",
      backdrop_path: "/5NTJZ571646mTziTOGt0jnq7uKe.jpg",
      id: 251937,
      name: "A Haunted House Collection",
      original_language: "en",
      original_name: "Haunted House Collection",
      overview: "A spoof of all the \"found-footage/documentary style\" films released in recent years.",
      poster_path: "/ycm511kfyzVVjRU70nxtAGjAPbQ.jpg"
    },
    {
      genre: "Adventure",
      backdrop_path: "/njFixYzIxX8jsn6KMSEtAzi4avi.jpg",
      id: 328,
      name: "Jurassic Park Collection",
      original_language: "en",
      original_name: "Jurassic Park Collection",
      overview: "An American science fiction adventure film series based on the novel of the same name by Michael Crichton. The films center on the fictional Isla Nublar near Costa Rica in the Central American Pacific Coast, where a billionaire philanthropist and a small team of genetic scientists have created an amusement park of cloned dinosaurs.",
      poster_path: "/qIm2nHXLpBBdMxi8dvfrnDkBUDh.jpg"
	 },
     {
      genre: "Adventure",
      backdrop_path: "/zJd4E0ImT1U6O8k6aX3ssc9iUBS.jpg",
      id: 295,
      name: "Pirates of the Caribbean Collection",
      original_language: "en",
      original_name: "Pirates of the Caribbean Collection",
      overview: "A series of fantasy swashbuckler films based on Walt Disney's theme park ride of the same name. The films follow the adventures of Captain Jack Sparrow and take place in a fictional historical setting; a world ruled by the British Empire, the East India Trading Company and the Spanish Empire, with pirates representing freedom from the ruling powers.",
      poster_path: "/zRBaZxS5YauLvRYjAdL4AUCwlht.jpg"
    },
    {
      genre: "Action",
      backdrop_path: "/5kHVblr87FUScuab1PVSsK692IL.jpg",
      id: 1570,
      name: "Die Hard Collection",
      original_language: "en",
      original_name: "Die Hard Collection",
      overview: "An action film series centered around the character of John McClane, a New York City police detective who finds himself fighting a group of terrorists in each film.",
      poster_path: "/xhnb5lVfwE7NHycdPNdIxHx7kZi.jpg"
    },
    {
      genre: "Animation",
      backdrop_path: "/gMWrKQjoTIpYjhc8SxZF20EDIES.jpg",
      id: 2150,
      name: "Shrek Collection",
      original_language: "en",
      original_name: "Shrek Collection",
      overview: "The fairytale story of a large, strong, solitude-loving, intimidating ogre named Shrek, and his friends.",
      poster_path: "/qveAMqXnqAObA4q6DbF487RZQy8.jpg"
    },
    {
      genre: "Animation",
      backdrop_path: "/9FBwqcd9IRruEDUrTdcaafOMKUq.jpg",
      id: 10194,
      name: "Toy Story Collection",
      original_language: "en",
      original_name: "Toy Story Collection",
      overview: "Toy Story is a CGI animated media franchise created by Pixar and distributed by Walt Disney Pictures. The franchise is based on the anthropomorphic concept that all toys, unknown to humans, are secretly alive, and the films focus on a diverse group of toys that feature a classic cowboy named Sheriff Woody and a modern spaceman named Buzz Lightyear. The group unexpectedly embark on adventures that challenge and change them.",
      poster_path: "/7G9915LfUQ2lVfwMEEhDsn3kT4B.jpg"
    },
    {
      genre: "Science Fiction",
      backdrop_path: "/RhUxjzNojIJsdZSYTn0CQvdKsn.jpg",
      id: 2344,
      name: "The Matrix Collection",
      original_language: "en",
      original_name: "The Matrix Collection",
      overview: "The Matrix collection depicts a complex science fiction story incorporating many philosophical elements. Written and directed by the Wachowskis and produced by Joel Silver.",
      poster_path: "/lh4aGpd3U9rm9B8Oqr6CUgQLtZL.jpg"
    },
    {
      genre: "Animation",
      backdrop_path: "/yPyhZ5OpYs68Bb8u0PZ1tH0QIgd.jpg",
      id: 87118,
      name: "Cars Collection",
      original_language: "fr",
      original_name: "Cars Collection",
      overview: "A computer-animated action-adventure comedy film series that follows the adventures of Lightning McQueen and Mater, set in a world populated entirely by anthropomorphic cars and other vehicles.",
      poster_path: "/uq3N2SFj1Y06zA6LzCQPkmBdaaE.jpg"
    },
    {
      genre: "Family",
      backdrop_path: "/6H6uS5f4SMBaN0xHNhmQqUOShAX.jpg",
      id: 85890,
      name: "The Librarian Collection",
      original_language: "en",
      original_name: "The Librarian Collection",
      overview: "Collection of The Librarian movie series",
      poster_path: "/w5sQ13yy83o1o323ksxz8RVxbqD.jpg"
    },
	{
      genre: "Action",
      backdrop_path: "/fSwYa5q2xRkBoOOjueLpkLf3N1m.jpg",
      id: 404609,
      name: "John Wick Collection",
      original_language: "en",
      original_name: "John Wick Collection",
      overview: "A neo-noir action thriller film series that follows a former assassin, Jonathan 'John' Wick who come outs of retirement seeking vengeance for the theft of his vintage car and the killing of his puppy.",
      poster_path: "/pZ4hR5IIoHHfNjot9rq4F96OGAi.jpg"
    },
    {
      genre: "Superhero",
      backdrop_path: "/QtSxEuCwcZSfCTMZfER3nHDVsG.jpg",
      id: 453993,
      name: "The Wolverine Collection",
      original_language: "en",
      original_name: "The Wolverine Collection",
      overview: "A superhero film series based on the comic book character of the same name published by Marvel Comics. The series centers on Wolverine a mutant possesses animal-keen senses, enhanced physical capabilities, powerful regenerative ability known as a healing factor, and three retractable claws in each hand. Wolverine's alter ego is James Howlett and he is also known as Logan or Weapon X.",
      poster_path: "/c18HVnKTybcAUYVQd8rOcdbqwY.jpg"
    },
    {
      genre: "Animation",
      backdrop_path: "/4VaLuyQvfXD4mH6Cu1L5apY9wLS.jpg",
      id: 306926,
      name: "Monsters Collection",
      original_language: "en",
      original_name: "Monsters Collection",
      overview: "After a NASA deep-space probe crash lands in Mexico, extraterrestrial life forms spread throughout the World",
      poster_path: "/2qar55qWUBH7jaLReRtWZ7jdLCu.jpg"
    },
    {
      genre: "Animation",
      backdrop_path: "/uzKkKhTWGSEdsN2rYanJTVAyTLi.jpg",
      id: 137696,
      name: "Monsters, Inc. Collection",
      original_language: "en",
      original_name: "Monsters, Inc. Collection",
      overview: "An American computer-animated comedy-adventure film series produced by Pixar Animation Studios",
      poster_path: "/sQwUqbmXA9PtknMvmJxZWkTOYXL.jpg"
    },
    {
      genre: "Action",
      backdrop_path: "/uoDt3eCCKpcxSQVWjPTgN8T0gjm.jpg",
      id: 90863,
      name: "Rush Hour Collection",
      original_language: "en",
      original_name: "Rush Hour Collection",
      overview: "The Rush Hour film series is a series of martial arts/action-comedy films starring Jackie Chan and Chris Tucker, directed by Brett Ratner, and distributed by New Line Cinema. The main plot centers around a pair of police detectives: a Chinese police inspector and an American LAPD detective who go on a series of misadventures often involving corrupt crime figures.",
      poster_path: "/pTjvzlYByJuZ4TTkmlHIe4aDFy2.jpg"
    },
    {
      genre: "Action",
      backdrop_path: "/z2TbwtEzjMxYZ8TXfbJmhbahkom.jpg",
      id: 304,
      name: "Ocean's Collection",
      original_language: "en",
      original_name: "Ocean's Collection",
      overview: "The Ocean's Collection is a star-studded film series about a group of professional robbers who get together to pull off some mind-boggling heists.",
      poster_path: "/oHUHccvraYF8lYp6BxRoujRtH8Q.jpg"
    },
    {
      genre: "Action",
      backdrop_path: null,
      id: 701183,
      name: "Ocean's Eight Collection",
      original_language: "en",
      original_name: "Ocean's Eight Collection",
      overview: "The Ocean's Collection is a star-studded film series about a group of professional robbers who get together to pull off some mind-boggling heists.",
      poster_path: "/1ZZsCbN0OJK6veJgCulmTSTfwPp.jpg"
    },
    {
      genre: "Horror",
      backdrop_path: "/oU1hA6PorJHcvsmhIdQOcxze6QC.jpg",
      id: 313086,
      name: "The Conjuring Collection",
      original_language: "en",
      original_name: "The Conjuring Collection",
      overview: "A supernatural horror film series that started The Conjuring Universe and follows Ed and Lorraine Warren, paranormal investigators and authors associated with prominent cases of haunting. Their reports inspired the Amityville Horror.",
      poster_path: "/z5VKhNSQKQyxm0co68HAkCqHnmX.jpg"
    },
    {
      genre: "Science Fiction",
      backdrop_path: "/cpmbkwSxZnKO69V82A9a34tvk2E.jpg",
      id: 528,
      name: "The Terminator Collection",
      original_language: "en",
      original_name: "The Terminator Collection",
      overview: "A series of science-fiction films about the futuristic conflict between the humans led by John Connor and the Terminators that are made and controlled by Skynet, a self-aware super computer that started Armageddon and may indeed end humanity for good. Skynet's most well-known products in its genocidal goals are the various terminator models, such as the T-800 (Model 101).",
      poster_path: "/vxiKtcxAJxHhlg2H1X8y7zcM3k6.jpg"
    },
    {
      genre: "Animation",
      backdrop_path: "/lzTIAbvMeGWB7PUrmBZXulGA28M.jpg",
      id: 14740,
      name: "Madagascar Collection",
      original_language: "en",
      original_name: "Madagascar Collection",
      overview: "Madagascar is an animated film series produced by DreamWorks Animation. Voices of Ben Stiller, Jada Pinkett Smith, Chris Rock and David Schwimmer are featured in the films. The plot follows the adventures of story of four Central Park Zoo animals who have spent their lives in blissful captivity and are unexpectedly shipped back to Africa.",
      poster_path: "/99VF9o8Zuq4mh5px4bBaZvcKyQS.jpg"
    },
    {
      genre: "Action",
      backdrop_path: "/vA5xMglyZv7yzDTj1qUTU4OvelV.jpg",
      id: 31562,
      name: "The Bourne Collection",
      original_language: "en",
      original_name: "The Bourne Collection",
      overview: "The Bourne films are a series of action thriller movies based on the character Jason Bourne, a CIA assassin suffering from extreme memory loss who must figure out who he is. The character is based on novels by Robert Ludlum. The fourth film in the series introduces Aaron Cross, a Department of Defense operative who runs for his life because of Bourne's actions.",
      poster_path: "/5wcNRGQ5oexJlJUkHyIFT5org4Z.jpg"
    },	
    {
      genre: "Animation",
      backdrop_path: "/2hC8HHRUvwRljYKIcQDMyMbLlxz.jpg",
      id: 137697,
      name: "Finding Nemo Collection",
      original_language: "en",
      original_name: "Finding Nemo Collection",
      overview: "A computer-animated adventure film series about a clownfish named Nemo, his over-protective father Marlin and a regal tang named Dory.",
      poster_path: "/xwggrEugjcJDuabIWvK2CpmK91z.jpg"
    },   
    {
      genre: "Adventure",
      backdrop_path: "/9f8kjuytZPJEPf1bhJgkekaoanr.jpg",
      id: 84,
      name: "Indiana Jones Collection",
      original_language: "en",
      original_name: "Indiana Jones Collection",
      overview: "The Adventure films series from the Director George Lucas and Steven Spielberg, starring Harrison Ford as the archeologist Dr. Henry Walton \"Indiana\" Jones, Jr..",
      poster_path: "/lpxDrACKJhbbGOlwVMNz5YCj6SI.jpg"
    },
    {
      genre: "Adventure",
      backdrop_path: "/3ZzA3b8K6ajpe4ZcLgqucDyNkoQ.jpg",
      id: 222049,
      name: "The Adventures of Young Indiana Jones Collection",
      original_language: "en",
      original_name: "The Adventures of Young Indiana Jones Collection",
      overview: "A series of 22 feature length films, each edited from two episodes of The Young Indiana Jones Chronicles.",
      poster_path: "/fYSPnTsA4Vj8vUWT7tX68PJV7br.jpg"
    },
    {
      genre: "Adventure",
      backdrop_path: "/xKz6YaOvmnIJQ3MYIpnaa7FBaAB.jpg",
      id: 86055,
      name: "Men In Black Collection",
      original_language: "en",
      original_name: "Men In Black Collection",
      overview: "A series of American science fiction action comedy films based on Malibu / Marvel comic book series The Men in Black by Lowell Cunningham. Stylized MIB and spawned 2 numbered sequels as well as a spin-off.",
      poster_path: "/rWcgZaoJ0nxTFRn0H6w9bdtoDUI.jpg"
    },
    {
      genre: "Animation",
      backdrop_path: "/1Jj7Frjjbewb6Q6dl6YXhL3kuvL.jpg",
      id: 529892,
      name: "Black Panther Collection",
      original_language: "en",
      original_name: "Black Panther Collection",
      overview: "Marvel's Black Panther film series",
      poster_path: "/9ZSPIsxI3TZDgfg0Jzk0RZl4INg.jpg"
    },
    {
      genre: "Science Fiction",
      backdrop_path: "/c9C9Pg2QctyjZHRmS0P8rZg1OTA.jpg",
      id: 264,
      name: "Back to the Future Collection",
      original_language: "en",
      original_name: "Back to the Future Collection",
      overview: "An American science fiction–comedy film series that follows the adventures of a high school student, Marty McFly and an eccentric scientist, Dr Emmett L. Brown as they use a DeLorean time machine to time travel to different periods in the history of Hill Valley, California.",
      poster_path: "/UV8VEgAxgKVnCVnZhFACmhxjE4.jpg"
    },
    {
      genre: "Action",
      backdrop_path: "/3WZTxpgscsmoUk81TuECXdFOD0R.jpg",
      id: 230,
      name: "The Godfather Collection",
      original_language: "en",
      original_name: "The Godfather Collection",
      overview: "Francis Ford Coppola’s trilogy films about the everyday life of a New York mafia family. With its star-studded cast these films would go down in history as some of the greatest Hollywood has ever produced.",
      poster_path: "/9Baumh5J9N1nJUYzNkm0xsgjpwY.jpg"
    },
    {
      genre: "Fantasy",
      backdrop_path: "/kriNR9A8Lhk2tFzbVQkhepXymEr.jpg",
      id: 33514,
      name: "The Twilight Collection",
      original_language: "en",
      original_name: "The Twilight Collection",
      overview: "The Twilight movies are a romantic fantasy vampire series based on the series of novels by Stephenie Meyer.",
      poster_path: "/aKAX2HO5V94JYeSIkOMFNlRI71E.jpg"
    },
    {
      genre: "Fantasy",
      backdrop_path: "/oboBn4VYB79uDxnyIri0Nt3U3N2.jpg",
      id: 535313,
      name: "Godzilla Collection",
      original_language: "en",
      original_name: "Godzilla Collection",
      overview: "An American multimedia franchise and shared fictional universe that is part of the MonsterVerse which is centered on a series of monster films featuring Godzilla and King Kong.",
      poster_path: "/inNN466SKHNjbGmpfhfsaPQNleS.jpg"
    },
    {
      genre: "Fantasy",
      backdrop_path: "/vlv2skpXYg02TRg1iyXGvDvZSZ9.jpg",
      id: 420,
      name: "The Chronicles of Narnia Collection",
      original_language: "en",
      original_name: "The Chronicles of Narnia Collection",
      overview: "Modern theatrical film productions based on the book series «The Chronicles of Narnia» by C. S. Lewis.",
      poster_path: "/sh6Kn8VBfXotJ6qsvJkdfscxXKR.jpg"
    },
    {
      genre: "Adventure",
      backdrop_path: "/2NQmgzxyzftJ1ZoUqPyO5TRGvfU.jpg",
      id: 2326,
      name: "Underworld Collection",
      original_language: "en",
      original_name: "Underworld Collection",
      overview: "A series of action horror films centered on Vampires and Lycans. In the 5th century, a man named Alexander Corvinus was the only survivor of a plague that wiped out his village. Somehow, Alexander's body was able to turn the disease to his own benefit and so he became the first true Immortal. Later, he fathered two sons who became the first Vampire and Lycan by being bitten by a bat and a wolf.",
      poster_path: "/aK8qq0X0pZbf5ncE3JLQ27hdC4F.jpg"
    },
    {
      genre: "Adventure",
      backdrop_path: "/1BeKi6IytbfQlQocJSvP2k6sO1a.jpg",
      id: 1733,
      name: "The Mummy Collection",
      original_language: "en",
      original_name: "The Mummy Collection",
      overview: "The Mummy film series is a remake of The Mummy, loosely based on the original 1932 film. The first two films in the series were written and directed by Stephen Sommers.",
      poster_path: "/4UMn5KmXopgpkC862Ms3t5j1sXl.jpg"
    },
    {
      genre: "Adventure",
      backdrop_path: "/aJQsaYuDvawCyXgjq8JepPI4tz.jpg",
      id: 2467,
      name: "Tomb Raider Collection",
      original_language: "en",
      original_name: "Tomb Raider Collection",
      overview: "Tomb Raider is a series of action-adventure movies, centering around the adventures of the female fictional British archaeologist Lara Croft.",
      poster_path: "/sgaP4WtVlKzz8FIcjbkevOycJiq.jpg"
    },
    {
      genre: "Science Fiction",
      backdrop_path: "/8utTJ9WoQeYcZ0Ztciv6auqwLXl.jpg",
      id: 17255,
      name: "Resident Evil Collection",
      original_language: "en",
      original_name: "Resident Evil Collection",
      overview: "The Resident Evil film series is loosely based upon the Capcom video games of the same name. The films follow the protagonist Alice, a character created for the films. The Umbrella Corporation acts as the main antagonist, a bioengineering pharmaceutical company responsible for the zombie apocalypse as a result of founding the T-virus.",
      poster_path: "/ed8cYt6V7DVoVuHhBV5dD2YRFvb.jpg"
    },
    {
      genre: "Animation",
      backdrop_path: "/TSpFZFIgVX4I3Zsnlm3HAlDO14.jpg",
      id: 133352,
      name: "Resident Evil: Biohazard Collection",
      original_language: "en",
      original_name: "Resident Evil: Biohazard Collection",
      overview: "Resident Evil: Biohazard Japanese CG Animated Collection. Sans Alice / Milla!",
      poster_path: "/i5BkIcEPSXqEcPiwrbwsVjS95FK.jpg"
    },
    {
      genre: "Animation",
      backdrop_path: "/2Mb92Ssoe1eUecvrCe2pEvgAlmv.jpg",
      id: 8354,
      name: "Ice Age Collection",
      original_language: "en",
      original_name: "Ice Age Collection",
      overview: "The Ice Age Movie Collection Release into theaters by Twentieth Century Fox Animation and Blue Sky Studios.",
      poster_path: "/stQoHvo0q6ZcEkji2Z1wlAxKnDq.jpg"
    },
    {
      genre: "Animation",
      backdrop_path: "/8wvxr06XNW2zofbOHQqEgokTmLx.jpg",
      id: 315595,
      name: "Tinker Bell Collection",
      original_language: "en",
      original_name: "Tinker Bell Collection",
      overview: "Tinker Bell is a computer animated film series produced by DisneyToon Studios as part of the Disney Fairies franchise. Voices of Mae Whitman, Raven-Symoné, Lucy Liu, America Ferrera, Kristin Chenoweth and Pamela Adlon are featured in the films. Each of the first four films is set around one of the four seasons: Tinker Bell around Spring, Tinker Bell and the Lost Treasure around Autumn, Tinker Bell and the Great Fairy Rescue around Summer, and Secret of the Wings around Winter. A fifth title, Pixie Hollow Games, was supposed to be based on all four seasons, but it was released before Secret of the Wings and scaled down. A sixth film, titled The Pirate Fairy, was released April 1, 2014, followed by the release of a seventh film Tinker Bell and the Legend of the NeverBeast on March 3, 2015. The series is a spin-off of and prequel to Peter Pan and its sequel, Return to Never Land.",
      poster_path: "/wzt5eeX5YeJ4CLi165id4dKEgfW.jpg"
    },
    {
      genre: "Adventure",
      backdrop_path: "/a0GLVfaDSf5GNZKK5H4FgGCD2VW.jpg",
      id: 52984,
      name: "National Treasure Collection",
      original_language: "en",
      original_name: "National Treasure Collection",
      overview: "The collection of theatrical action-adventure mystery films starring Nicolas Cage as Benjamin Gates, a treasure hunter who, with the help of his father, Patrick Henry Gates (Jon Voight), his girlfriend, Abigail Chase (Diane Kruger) and his loyal sidekick, Riley Poole (Justin Bartha), uncovers hidden troves and secrets from America's past.",
      poster_path: "/z5EIRaI8XS0brelYwDFEVlxcpzM.jpg"
    },
    {
      genre: "Animation",
      backdrop_path: "/uDosHOFFWtF5YteBRygHALFqLw2.jpg",
      id: 77816,
      name: "Kung Fu Panda Collection",
      original_language: "en",
      original_name: "Kung Fu Panda Collection",
      overview: "The Kung Fu Panda series are computer-animated action comedy films set in a version of old China populated by humanoid talking animals, the plot revolves around a bumbling humanoid panda named Po who aspires to be a kung fu master.",
      poster_path: "/2QT6PuYXY0T2Ry9rX0JKQYTrbwx.jpg"
    },    
    {
      genre: "Animation",
      backdrop_path: "/qI483yHct3PBtIiOH3K3SVNUDq5.jpg",
      id: 167613,
      name: "Alvin and the Chipmunks Collection",
      original_language: "de",
      original_name: "Alvin and the Chipmunks Collection",
      overview: "Alvin and the Chipmunks is a 2007 American live-action comedy film directed by Tim Hill. Based on the characters of the same name created by Ross Bagdasarian, Sr., the film stars Jason Lee, David Cross, and Cameron Richardson with the voices of Justin Long, Matthew Gray Gubler and Jesse McCartney. The first film was followed by three sequels: Alvin and the Chipmunks: The Squeakquel, released on December 23, 2009, Alvin and the Chipmunks: Chipwrecked, released on December 16, 2011 and Alvin and the Chipmunks: The Road Chip, released on December 18, 2015.",
      poster_path: "/fLvRQcuk5ZFKnDvUC553XK3OnPC.jpg"
    },
    {
      genre: "Animation",
      backdrop_path: "/syWm5FMScW6JHaCM2C9aduCzUtp.jpg",
      id: 86029,
      name: "Charlie's Angels Collection",
      original_language: "en",
      original_name: "Charlie's Angels Collection",
      overview: "An American media franchise that follows the adventures of the Angels, a team of women working for the Townsend Agency, a private detective agency, under the leadership of Charlie Townsend, their unseen boss. The film series is a continuation of the story with later generations of Angels.",
      poster_path: "/jBKUntSuSUfxTXI8XWABpdWmWEt.jpg"
    },
    {
      genre: "Animation",
      backdrop_path: "/iVqkNuy2jpcurdk2ZH2iAexJTo6.jpg",
      id: 437451,
      name: "Cinderella Story Collection",
      original_language: "en",
      original_name: "Cinderella Story Collection",
      overview: "A Cinderella Story is a 2004 American romantic comedy film directed by Mark Rosman, written by Leigh Dunlap and stars Hilary Duff, Chad Michael Murray, Jennifer Coolidge and Regina King. A modernization of the classic Cinderella folk lore, the film's plot revolves around two Internet pen pals who plan meet in person at their high school's Halloween dance. The film was followed by four direct-to-video sequels, Another Cinderella Story (2008), A Cinderella Story: Once Upon a Song (2011), A Cinderella Story: If the Shoe Fits (2016), A Cinderella Story: Christmas Wish (2019), and A Cinderella Story: Christmas Wish\t(2019). The sequels using the themes and situations but not containing any characters from the first film. Unlike the first film, the sequels also include musical, dance, and holiday themes.",
      poster_path: "/65raP1FRJpPC5GVWVvemQ3kLAKG.jpg"
    }, 
    {
      genre: "Comedy", //"comedy, Drama,Family"
      backdrop_path: "/t1mwGPJi3NkwMeyeUHr9zlQhlTo.jpg",
      id: 87253,
      name: "High School Musical Collection",
      original_language: "en",
      original_name: "High School Musical Collection",
      overview: "The High School Musical film series chronicles two high school students, Troy Bolton, captain of East High School’s basketball team (Wildcats) and Gabriella Montez, a shy top student. Both of them try out for the lead roles in their school's musical and quickly fall in love in the process, despite the lack of support from the rest of their classmates, one of them being Sharpay Evans and her brother sidekick Ryan Evans. The film also focuses on Chad Danforth, Troy's best friend and Taylor McKessie, Gabriella's best friend who fall in love, too.",
      poster_path: "/dXIgM9sEWIkUfRH8GZUKHv1t5n.jpg"
    },
    {
      genre: "Adventure",
      backdrop_path: "/wZCWCe4jPJz04dvVGLQ8TtOq9Js.jpg",
      id: 1657,
      name: "Zorro Collection",
      original_language: "en",
      original_name: "Zorro Collection",
      overview: "",
      poster_path: "/hy8YFvaURGzKFoBbB8ajjzlWQne.jpg"
    },
    {
      genre: "Comedy",
      backdrop_path: "/z0nqqHwEY3niKa41kKbR4zhnvHw.jpg",
      id: 85943,
      name: "Night at the Museum Collection",
      original_language: "en",
      original_name: "Night at the Museum Collection",
      overview: "The series of movies starring Ben Stiller as a night guard of the Museum of Natural History in New York City.",
      poster_path: "/q2nwE0Qi8U6tsU5HDmiWS2D3dSJ.jpg"
    },   
    {
      genre: "Animation",
      backdrop_path: "/uzQqTJMTCcAbXCg3LUsiA8cJ5m0.jpg",
      id: 87236,
      name: "Mulan Collection",
      original_language: "en",
      original_name: "Mulan Collection",
      overview: "The Mulan Collection is a series of movies following the adventures of Mulan.",
      poster_path: "/1fjZKATXsAKvtO6uJqCiNL5u4mK.jpg"
    },
    {
      genre: "Animation",
      backdrop_path: "/naeLgo2bt4WKfHF4BTrG6mkmjiY.jpg",
      id: 86027,
      name: "Aladdin Collection",
      original_language: "en",
      original_name: "Aladdin Collection",
      overview: "Movie series of Disney's Aladdin",
      poster_path: "/enl57YvMhTAdic6El5rfZppyzq2.jpg"
    },
    {
      genre: "Animation",
      backdrop_path: '/qNNOYLWLlEQARRT0z37DSrWx3NV.jpg',
      id: 33085,
      name: 'The Little Mermaid Collection',
      original_language: 'en',
      original_name: 'The Little Mermaid Collection',
      overview: "The Little Mermaid is a 1989 American animated musical fantasy film produced by Walt Disney Feature Animation and released by Walt Disney Pictures. Based on the Danish fairy tale of the same name by Hans Christian Andersen, The Little Mermaid II: Return to the Sea is a direct-to-video sequel to the first film. It was released by Walt Disney Studios Home Entertainment on VHS in the United States on September 19, 2000. The Little Mermaid: Ariel's Beginning is a direct-to-video prequel to the first film. The film was released on Region 1 DVD in the United States on August 26, 2008, and on Region 2 DVD in Europe on September 22, 2008.",
      poster_path: '/y0EOuK02TasfRGSZBdv5U910QaV.jpg'
    },
    {
      genre: "Animation",
      backdrop_path: '/hw43q6AkuoRDFvuSWsxDG0A5AK6.jpg',
      id: 422361,
      name: 'Barbie A Mermaid Tale Collection',
      original_language: 'en',
      original_name: 'Barbie A Mermaid Tale Collection',
      overview: 'A collection of films with Barbie as Merliah.',
      poster_path: '/xvvY9hj10DQjAwN2NCaFJS1Moii.jpg'
    }, 
    {
      genre: "Animation",
      backdrop_path: '/fw6YfVOmK0tVtaSUGb3GvLzEmvK.jpg',
      id: 141084,
      name: "Happily N'Ever After Collection",
      original_language: 'en',
      original_name: "Happily N'Ever After Collection",
      overview: '',
      poster_path: '/2BrrlkzelaRFNUy23zqv1IKuZdh.jpg'
    },
    {
      genre: "Horror",
      backdrop_path: null,
      id: 535121,
      name: "Halloween Nightmare Collection",
      original_language: "en",
      original_name: "Halloween Nightmare Collection",
      overview: "A Japanese series of horror films created by Kotaro Terauchi,Yoshitsugu Sagami and Ivory Dice following an unsolved Halloween mystery",
      poster_path: null
    },
    {
      genre: "Western",
      backdrop_path: null,
      id: 492980,
      name: "Bonanza Movie Collection",
      original_language: "en",
      original_name: "Bonanza Movie Collection",
      overview: "",
      poster_path: null
    },
    {
      adult: "College",
      backdrop_path: "/pkRyV44Zyn6KOySQQT9DHbAhT8D.jpg",
      id: 201778,
      name: "Dorm Daze Collection",
      original_language: "sv",
      original_name: "Dorm Daze Collection",
      overview: "",
      poster_path: "/zw4H0deFWWoktReTmiRSdLYj3F9.jpg"
    },
    {
      adult: "College",
      backdrop_path: "/afX0zjd1fFYNXrndzD9jd7gHvi3.jpg",
      id: 43220,
      name: "National Lampoon's Van Wilder Collection",
      original_language: "en",
      original_name: "National Lampoon's Van Wilder Collection",
      overview: "Van Wilder (Ryan Reynolds) is an outgoing, friendly, and extremely popular student who has been at Coolidge College for seven years. For the past six years, he has made no effort to graduate, instead spending his time organizing parties and fundraisers, doing charity work, helping other students, and posing for figure drawing classes. But after seven years, with no return on his investment, Van's father (Tim Matheson) decides it is time to cut his losses and stops paying Van's tuition.",
      poster_path: "/9O9Dtdetrc7shP2CUr5jQqbIexC.jpg"
    },
    {
      adult: "Animation",
      backdrop_path: "/lB4l8H0jgPp2bf4NV2aZPIyytdQ.jpg",
      id: 427084,
      name: "The Secret Life of Pets Collection",
      original_language: "en",
      original_name: "The Secret Life of Pets Collection",
      overview: "The lives of a group of pets in Manhattan.",
      poster_path: "/5uYBl9BNxbf5M64V33vdOUW5t1g.jpg"
    },
    {
      adult: "Superhero",
      backdrop_path: "/xKL7q00o6kIME7h8XY9gu3CcaDt.jpg",
      id: 593251,
      name: "The Death of Superman Collection",
      original_language: "en",
      original_name: "The Death of Superman Collection",
      overview: "This collection expands the story line of Superman within the DC Animated Movie Universe.  When a hulking monster arrives on Earth and begins a mindless rampage, the Justice League is quickly called in to stop it. But it soon becomes apparent that only Superman can stand against the monstrosity.  In the wake of The Death of Superman, the world is still mourning the loss of the Man of Steel following his fatal battle with the monster Doomsday. However, no sooner as his body been laid to rest than do four new bearers of the Superman shield come forward to take on the mantle. The Last Son of Krypton, Superboy, Steel, and the Cyborg Superman all attempt to fill the vacuum left by the world's greatest champion. Meanwhile, Superman's death has also signaled to the universe that Earth is vulnerable. Can these new Supermen and the rest of the heroes prove them wrong?",
      poster_path: "/iql6qdL7FUFUAdFgpRierIk1HUA.jpg"
    },
    {
      genre: "Action",
      backdrop_path: null,
      id: 606601,
      name: "Commando Collection",
      original_language: "en",
      original_name: "Commando Collection",
      overview: "No overview",
      poster_path: null
    },
    {
      genre: "Action",
      backdrop_path: null,
      id: 537303,
      name: "Strike Commando Collection",
      original_language: "it",
      original_name: "Strike Commando Collection",
      overview: "",
      poster_path: null
    },                                                                             
      ]
    }
  },
  methods: {
    infiniteHandler ($state) {
      let self = this
      axios.get(`/3/search/collection?api_key=a11ac97c6bdb99adc0845654be0902a8&language=en-US&query=collection&page=${this.page}`)
        .then(response => {
          this.page += 1
          // self.pagination = response.data.data
            //if (Array.isArray(self.dorms) && Array.isArray(response.data.data.data) !== true && Object.keys(response.data.data.data).length !== 0) {
            if (response.data.results.length !== 0 ) {              
              response.data.results.forEach(item => {
                self.movies.push(item)
              })
              $state.loaded()
            } else {
              $state.complete()
            }          
          // self.dorms = response.data.data.data
       //   self.popupDorms = response.data.popups
        })
        .catch(e => {
          self.errors.push(e)
        })      
    },    
    selectGenre(opt) {/*
      this.list.filter(item => {
          if(item.code) {
          return item.origin_country== opt.code
          } else return ''
        })
*/
if(opt.name == 'All Genres') {
  this.movies = this.list
}
else {
this.movies = this.list.filter(function (el) {
  return el.genre == opt.name
})
}
// this.movies = newArray
    },
    toggle (index) {
      // this.accordions.forEach((item) => {
      //   item.active = false
      // })
      this.accordions[index].active = !this.accordions[index].active
    },
    getMovies () {
      let self = this
      axios.get('/3/search/collection?api_key=a11ac97c6bdb99adc0845654be0902a8&language=en-US&query=collection&page=1')
        .then(response => {
          self.movies = response.data.results
          self.total_results = response.data.total_results
        })
        .catch(e => {
          this.errors.push(e)
        })
    }
  },
  created () {
    // this.movies = this.list
    this.getMovies()
  },
  computed: {
    mobileCheck() {
     var check = false;
      (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
      return check
  },
    getFiltered (options) {
        return this.countries.filter(item => {
          if(item.name) {
          return item.name.toLocaleUpperCase().indexOf(this.search.toLocaleUpperCase()) !== -1
          } else return ''
        })
    },        
  }
}
</script>

<style lang="scss">
  @import "../assets/scss/components/uni-search";
</style>
